import React, { useState, useMemo } from "react";
import Gallery from "react-bnb-gallery";
import "react-bnb-gallery/dist/style.css";
import { slimImage } from "@/service/utils";
import "./index.less";
import NoDish from "@/images/no_dish_picture.svg";

/**横幅 */
export default ({ photos, cover }) => {
  const [show, setShow] = useState(false);
  function showPhotos() {
    setShow(true);
  }
  const photoList = photos.map((i) => {
    return {
      photo: i.picture_url,
    };
  });
  return (
    <React.Fragment>
      {photos.length ? (
        <section className="dc-banner">
          <div className="banner-inner" onClick={showPhotos}>
            <img
              src={slimImage(cover || photos[0].picture_url)}
              className="banner-bg"
            />
            <div className="banner-tag">
              <i className="icon icon-pic"></i>
              <span>{photos.length}</span>
            </div>
          </div>
          <Gallery
            onClose={() => setShow(false)}
            photos={photoList}
            show={show}
            showThumbnails={false}
          ></Gallery>
        </section>
      ) : null}
    </React.Fragment>
  );
};

export const Empty = () => {
  return (
    <section className="dc-banner">
      <div className="banner-inner">
        <img src={NoDish} className="banner-bg" />
        <div className="banner-tag">
          <i className="icon icon-pic"></i>
          <span>0</span>
        </div>
      </div>
    </section>
  );
};
